import React from "react";
import {
  Monitor,
  X,
  Sparkles,
  Bold,
  Italic,
  Underline,
  List,
  Quote,
  Link2,
  Image as ImageIcon,
} from "lucide-react";

export default function BlogWriteDesktopOnly() {
  return (
    <div className="flex flex-col items-center text-center px-6 py-14 max-w-sm mx-auto">
      <div className="relative w-full flex items-center justify-center mb-10 pt-4">
        <div className="absolute inset-0 -z-10 rounded-[40%] bg-[#F4F1FC]" />
        <Sparkles className="absolute -top-1 left-6 w-4 h-4 text-[#7209B7]/40" />
        <span className="absolute top-10 right-3 w-2 h-2 rounded-full bg-[#7209B7]/30" />
        <span className="absolute bottom-4 left-4 w-2 h-2 rounded-full bg-[#7209B7]/30" />

        {/* Monitor mockup */}
        <div className="relative w-56">
          <div className="rounded-xl border-4 border-slate-800 bg-white overflow-hidden shadow-lg">
            <div className="flex items-center justify-between px-3 py-2 border-b border-slate-100">
              <span className="text-[#7209B7] font-extrabold text-xs tracking-wide">
                BLOG
              </span>
              <span className="flex gap-0.5">
                <span className="w-1 h-1 rounded-full bg-slate-300" />
                <span className="w-1 h-1 rounded-full bg-slate-300" />
                <span className="w-1 h-1 rounded-full bg-slate-300" />
              </span>
            </div>
            <div className="flex items-center gap-1.5 px-3 py-1.5 border-b border-slate-100 text-slate-400">
              <Bold className="w-3 h-3" />
              <Italic className="w-3 h-3" />
              <Underline className="w-3 h-3" />
              <List className="w-3 h-3" />
              <Quote className="w-3 h-3" />
              <Link2 className="w-3 h-3" />
            </div>
            <div className="p-3 flex gap-2">
              <div className="w-10 h-10 rounded-md bg-purple-100 flex items-center justify-center shrink-0">
                <ImageIcon className="w-4 h-4 text-[#7209B7]" />
              </div>
              <div className="flex-1 flex flex-col gap-1.5 justify-center">
                <span className="h-1.5 rounded bg-slate-100 w-full block" />
                <span className="h-1.5 rounded bg-slate-100 w-4/5 block" />
                <span className="h-1.5 rounded bg-slate-100 w-2/3 block" />
              </div>
            </div>
          </div>
          <div className="mx-auto w-3 h-4 bg-slate-800" />
          <div className="mx-auto w-16 h-1.5 rounded-full bg-slate-800" />
        </div>

        {/* Phone with blocked badge */}
        <div className="absolute right-0 bottom-3 w-14 h-24 rounded-xl border-2 border-[#7209B7]/40 bg-white shadow-md">
          <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-purple-100 flex items-center justify-center">
            <X className="w-3.5 h-3.5 text-[#7209B7]" />
          </span>
        </div>
      </div>

      <div className="w-10 h-10 rounded-full bg-[#7209B7] flex items-center justify-center mb-6">
        <Monitor className="w-5 h-5 text-white" />
      </div>

      <h2 className="text-2xl font-extrabold text-slate-900 leading-snug mb-3">
        Blog writing is available
        <br /> on <span className="text-[#7209B7]">desktop</span>
      </h2>
      <p className="text-sm text-slate-500 leading-relaxed">
        To create and publish your blog, please use SoloConnect on a desktop
        or laptop
      </p>
    </div>
  );
}
